module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/assets/images/sgcc-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"45c89d271794585f5eb244095e09aada"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
